import { confirmable, createConfirmation } from "react-confirm";
import GenericModal from "../components/common/GenericModal";

export const openModal = (options) => {
  return createConfirmation(confirmable(GenericModal))(options);
};
